<template>
  <div class="col-12 col-sm-6 col-md-3">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-success elevation-1"
        ><i class="fas fa-shopping-cart"></i
      ></span>

      <div class="info-box-content">
        <span class="info-box-text text-bold">Total Resolved</span>
        <span class="info-box-number">{{ TicketResolved }}</span>
      </div>
      <!-- /.info-box-content -->
    </div>
    <!-- /.info-box -->
  </div>
  
</template>

<script>
export default {
  name: "ticket-counter-lifetime-resolved",
  data() {
    return {
      TicketResolved: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>